import { FrameMonitor } from './FrameMonitor.js';

export const frameMonitor = new FrameMonitor();
const marks = {};
const sources = new Map();
export function markBoot(name, detail = null) {
  if (marks[name]) return;
  marks[name] = { atMs: Math.round(performance.now() * 100) / 100, detail };
  performance.mark?.(`chaos:${name}`);
}
export function registerDiagnostics(name, read) {
  sources.set(name, read);
}
export function runtimeDiagnostics() {
  const diagnostics = {};
  for (const [name, read] of sources) {
    try { diagnostics[name] = read(); } catch { diagnostics[name] = { unavailable: true }; }
  }
  return { boot: { ...marks }, ...diagnostics };
}
export async function sampleFrames(frames = 600, options) {
  const result = await frameMonitor.sample(frames, options);
  return { ...result, ...runtimeDiagnostics() };
}
export function installPerformanceDebug() {
  window.chaosPerf = {
    sample: sampleFrames,
    stats: () => ({ ...frameMonitor.stats(), ...runtimeDiagnostics() }),
    // Dynamic: the bench pulls in the whole VFX kit and nobody but a profiler
    // should pay for that import.
    vfxBench: (options) => import('./vfxbench.js').then((m) => m.runVfxBench(options)),
  };
}
if (typeof document !== 'undefined') {
  frameMonitor.setVisible(!document.hidden);
  document.addEventListener('visibilitychange', () => frameMonitor.setVisible(!document.hidden));
}
